// extracted by mini-css-extract-plugin
export var subtitle = "_co-2";
export var title = "_co-0";
export var titleNoWrap = "_co-1";